module.exports = __webpack_public_path__ + "media/images/Branding/HW Mark 1-1435b16ae7eb754d07597d14380e28f9.png";